import React from 'react';
import BaseParametroCrud from './BaseParametroCrud';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';

export default function TipoAtencionDdhh() {
    const { token } = useAuth();
    const [tipoAyudasDdhh, setTipoAyudasDdhh] = React.useState([]);
    React.useEffect(() => {
        fetchTipoAyudasDdhh();
    }, []);

    const fetchTipoAyudasDdhh = async () => {
        try {
            const response = await apiService.get('/parametros/tipoayudaddhh', token);
            const result = await response.data;
            setTipoAyudasDdhh(result);
        } catch (error) {
            console.error('Error fetching tipo ayudas DDHH:', error);
        }
    };

    return (
        <BaseParametroCrud
            header={{
                title: 'Tipo atencion DDHH',
                idCabezaFamilia: '1',
                url: '/parametros',
                nombreurl: 'Parámetros',
                nombreform: 'Tipo atencion DDHH'
            }}
            formTitle="Formulario tipo atencion DDHH"
            loadUrl="/parametros/tipoatencionddhh"
            saveUrl="/parametros/guardartipoatencionddhh"
            alertTitle="Guardar tipo atencion DDHH"
            defaultValues={{
                id: 0,
                strNombre: '',
                intIdtipoayudaddhh: 0,
                strNombreTipoAyuda: '',
                bolActivo: false
            }}
            mapRowToForm={(row) => ({
                id: row.id,
                strNombre: row.strNombre,
                intIdtipoayudaddhh: row.intIdtipoayudaddhh,
                strNombreTipoAyuda: row.strNombreTipoAyuda,
                bolActivo: row.bolActivo
            })}
            columns={[
                { key: 'id', title: 'Id' },
                { key: 'strNombre', title: 'Nombre' },
                { key: 'strNombreTipoAyuda', title: 'Tipo Ayuda' },
                {
                    key: 'bolActivo',
                    title: 'Estado',
                    render: (row) => (row.bolActivo ? 'Activo' : 'Inactivo')
                }
            ]}
            renderFormFields={({ register, errors }) => (
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="strNombre">Nombre</label>
                                <input
                                    {...register('strNombre', { required: true })}
                                    className="form-control"
                                    placeholder="Nombre"
                                    id="strNombre"
                                />
                                {errors.strNombre && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="intIdtipoayudaddhh">Tipo Ayuda DDHH</label>
                                <select
                                    {...register('intIdtipoayudaddhh', { required: true })}
                                    className="form-control"
                                    id="intIdtipoayudaddhh"
                                >
                                    <option value="">Seleccionar tipo ayuda</option>
                                    {tipoAyudasDdhh.map((tipoAyuda) => (
                                        <option key={tipoAyuda.id} value={tipoAyuda.id}>
                                            {tipoAyuda.strNombre}
                                        </option>
                                    ))}
                                </select>
                                {errors.intIdtipoayudaddhh && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolActivo')}
                                        className="custom-control-input"
                                        id="SwitchEstado"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}